import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const PrivateRoute: React.FC = () => {
  const { currentAuthUser } = useAuth();

  return currentAuthUser ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;